import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../../ui/Layout';

import CreateAsset from './CreateAsset';
import EditAsset from './EditAsset';
import AssetList from './AssetList';
import AssetDetail from './AssetDetail';

export default ({ match }) => (
  <Layout route="assets">
    <Switch>
      <Route exact path={`${match.url}/:type?`} component={AssetList} />
      <Route exact path={`${match.url}/:type/create/:assetParentId?`} component={CreateAsset} />
      <Route exact path={`${match.url}/:type/:id`} component={AssetDetail} />
      <Route exact path={`${match.url}/:type/edit/:id`} component={EditAsset} />
    </Switch>
  </Layout>
);



// WEBPACK FOOTER //
// ./src/components/routes/assets/Assets.js